module.exports = __webpack_public_path__ + "static/media/qr-code-mobile-bottom02.8788db2f.png";